import * as Yup from 'yup';

import { NO_LEADING_TRAILING_SPACES_VALIDATION, INTEGER_VALIDATION } from '@/shared/consts';
import { ESchoolBadgeIcons, ESchoolFormat, ESchoolType } from '@/shared/types';

/**
 * Перевод статуса школы в текст
 */
export enum ESchoolTypeToText {
  Published = 'Опубликовано',
  UnPublished = 'Не опубликовано',
}

export const PUBLIC_SCHOOL_VALIDATION_SCHEMA = Yup.object().shape({
  title: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    200,
    'Превышено допустимое количество символов',
  ),
  logo: Yup.object({
    filename: Yup.string().required(),
    signed_id: Yup.string(),
    url: Yup.string(),
  })
    .nullable()
    .test('required', 'Обязательное поле', (value) => value !== null),
  icon: Yup.string().oneOf(Object.values(ESchoolBadgeIcons)),
  description: NO_LEADING_TRAILING_SPACES_VALIDATION.max(500, 'Превышено допустимое количество символов'),
  shortDescFirst: NO_LEADING_TRAILING_SPACES_VALIDATION.max(45, 'Превышено допустимое количество символов'),
  shortDescSecond: NO_LEADING_TRAILING_SPACES_VALIDATION.max(45, 'Превышено допустимое количество символов'),
  shortDescThird: NO_LEADING_TRAILING_SPACES_VALIDATION.max(45, 'Превышено допустимое количество символов'),
  shortDescFourth: NO_LEADING_TRAILING_SPACES_VALIDATION.max(45, 'Превышено допустимое количество символов'),
  duration: INTEGER_VALIDATION,
  certification: Yup.boolean(),
  cityIds: Yup.array().of(Yup.number().required()).nullable(),
  lmsAccountId: Yup.number()
    .nullable()
    .test('required', 'Обязательное поле', (value) => value !== null && value !== undefined),
  pollId: Yup.number().nullable(),
  testId: Yup.number().nullable(),
  format: Yup.string()
    .oneOf([ESchoolFormat.Hybrid, ESchoolFormat.Offline, ESchoolFormat.Online])
    .required('Обязательное поле'),
  onlineDescription: Yup.string().when('format', {
    is: ESchoolFormat.Online,
    then: (schema) => schema.max(150, 'Превышено допустимое количество символов').nullable(),
    otherwise: (schema) => schema,
  }),
  offlineDescription: Yup.string().when('format', {
    is: ESchoolFormat.Offline,
    then: (schema) => schema.max(150, 'Превышено допустимое количество символов').nullable(),
    otherwise: (schema) => schema,
  }),
  hybridDescription: Yup.string().when('format', {
    is: ESchoolFormat.Hybrid,
    then: (schema) => schema.max(150, 'Превышено допустимое количество символов').nullable(),
    otherwise: (schema) => schema,
  }),
});

export const CORPORATE_SCHOOL_VALIDATION_SCHEMA = Yup.object().shape({
  title: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    200,
    'Превышено допустимое количество символов',
  ),
  lmsAccountId: Yup.number()
    .nullable()
    .test('required', 'Обязательное поле', (value) => value !== null && value !== undefined),
});

export const SHORT_DESC_INDEX_TO_FIELD_NAME_MAPPER: Record<number, string> = {
  0: 'shortDescFirst',
  1: 'shortDescSecond',
  2: 'shortDescThird',
  3: 'shortDescFourth',
};

export const SCHOOL_FORMAT_RADIO_GROUP_DATA = [
  {
    id: 1,
    data: {
      format: ESchoolFormat.Online,
      buttonText: 'Онлайн',
      inputTitle: 'Описание онлайн-преимуществ',
      fieldName: 'onlineDescription',
      inputPlaceholder: 'Видеолекции, учебные материалы, онлайн-тестирование',
    },
  },
  {
    id: 2,
    data: {
      format: ESchoolFormat.Offline,
      buttonText: 'Офлайн',
      inputTitle: 'Описание офлайн-преимуществ',
      fieldName: 'offlineDescription',
      inputPlaceholder: 'Живое общение с экспертами, практические воркшопы, групповые обсуждения',
    },
  },
  {
    id: 3,
    data: {
      format: ESchoolFormat.Hybrid,
      buttonText: 'Гибрид',
      inputTitle: 'Описание гибридных преимуществ',
      fieldName: 'hybridDescription',
      inputPlaceholder: 'Сочетание онлайн-лекций и офлайн-воркшопов, видеозаписи всех занятий, персональный куратор',
    },
  },
];

export const SCHOOL_TYPE_TO_TEXT_MAPPER = {
  [ESchoolType.Corporate]: 'Корпоративная',
  [ESchoolType.Public]: 'Публичная',
};
